<style scoped>
.line-separator {
    content: '';
    @apply block my-2;
    @apply border-b border-dotted;
}
.tooltip {
    position: relative;
    display: inline-block;
}

/* Tooltip text */
.tooltip .tooltiptext {
    font-size: 0.5rem;
    visibility: hidden;
    width: 100px;
    background-color: black;
    color: #fff;
    text-align: center;
    padding: 5px 0;
    border-radius: 6px;

    position: absolute;
    top: -10px;
    z-index: 1;
    left: 110%;

    @apply font-normal;
}

.tooltip:hover .tooltiptext {
    visibility: visible;
}

.tooltip .tooltiptext::after {
    content: ' ';
    position: absolute;
    top: 50%;
    right: 100%;
    margin-top: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent black transparent transparent;
}
</style>

<template>
    <div>
        <breadcrumb :links="links" />
        <productInfo
            v-if="product"
            :product="product"
            :productLinks="productLinks"
            :showProdDespImg="true"
        >
            <div
                class="text-start w-full text-red text-sm sm:mr-3 my-2"
                v-if="maxCustOrdQty"
            >
                ({{ $t('product.max.qty.long', maxCustOrdQty) }})
            </div>
            <div class="line-separator" />
            <div
                class="flex text-sm text-gray-650 font-extrabold leading-none mt-4 mb-2"
                v-if="product.prodRefPrcAmt"
            >
                <div class="w-20 whitespace-no-wrap">
                    {{ saleCatgRefPrcName }}
                    :
                </div>
                <div>{{ product.prodRefPrcAmt | price }}</div>
            </div>
            <div class="flex text-lg leading-none mb-4">
                <div class="icon text-primary mr-2">
                    <tryhalaCoinSvg />
                </div>
                <div class="flex flex-grow items-center font-extrabold">
                    <div class="font-extrabold">
                        {{
                            product.prodUnitCrdtPntQty ||
                                '待定' | numberWithCommas
                        }}
                    </div>
                </div>
            </div>
            <div class="flex items-center text-lg font-semibold leading-none">
                <div class="w-20 whitespace-no-wrap">
                    {{ $t('product.qty') }} :
                </div>
                <div class="flex-1">
                    <quantityInput
                        v-model="quantity"
                        :max="maxQty"
                        class="w-full bg-white"
                    />
                </div>
            </div>
            <div class="w-full mt-2">
                <div class="flex flex-wrap items-center">
                    <buttonRedeemGift
                        :disabled="
                            productActualRemainingQty <= 0 ||
                                !isRdmGiftShopListOpen ||
                                product.prodUnitCrdtPntQty === undefined ||
                                product.prodUnitCrdtPntQty === null
                        "
                        :product="product"
                        @add="$refs['rdmGiftModal'].show = true"
                        class="bg-secondary mr-2"
                    />
                    <slot name="button"></slot>
                </div>
                <div
                    v-if="
                        product.prodUnitPrcAmt !== undefined &&
                            product.prodUnitPrcAmt !== null
                    "
                >
                    <div
                        class="text-red text-base"
                        v-if="productActualRemainingQty <= 0"
                    >
                        <template
                            v-if="
                                product.pgsProdSaleQtyInd === 'Y' &&
                                    product.rmnProdQty >
                                        productActualRemainingQty
                            "
                        >
                            <div class="tooltip">
                                {{ $t('product.pgs.zero.qty') }}
                                <span class="tooltiptext">
                                    {{ $t('product.pgs.zero.qty.tooltip') }}
                                </span>
                            </div>
                        </template>
                        <template v-else>
                            {{ $t('product.zero.qty') }}
                        </template>
                    </div>
                    <div
                        v-else-if="product.pgsProdSaleQtyInd === 'Y'"
                        style="color: orange"
                    >
                        {{ $t('product.pgs.sale') }}
                    </div>
                </div>
            </div>
        </productInfo>
        <rdmGiftModal
            ref="rdmGiftModal"
            :product="product"
            :quantity="quantity"
        />
    </div>
</template>

<script>
import productInfo from '@/components/productInfo.vue';
import price from '@/components/priceFilter';
import tryhalaCoinSvg from '@/assets/svg/tryhala_coin.svg';
import quantityInput from '@/components/quantityInput.vue';
import buttonRedeemGift from '@/components/buttonRedeemGift.vue';
import breadcrumb from '@/components/breadcrumb.vue';
import rdmGiftModal from '@/components/rdmGiftModal.vue';
import numberWithCommas from '@/components/numberWithCommasFilter.js';

export default {
    components: {
        productInfo,
        quantityInput,
        tryhalaCoinSvg,
        buttonRedeemGift,
        rdmGiftModal,
        breadcrumb
    },
    filters: { price, numberWithCommas },
    data() {
        return { quantity: 1 };
    },
    computed: {
        links() {
            const prodGroupLink = {
                msg: '換領禮品',
                route: '/rdmGift'
            };
            const prodCatgLink = {
                msg: this.prodCatgDesp,
                route: `/rdmGift/${this.product.prodCatgSlctKey || ''}`
            };
            const prodLink = {
                text: this.$config.showProdName
                    ? this.productDisplayFullname
                    : this.$t('product.info')
            };

            const links = [];
            links.push(prodGroupLink);
            links.push(prodCatgLink);
            links.push(prodLink);
            return links;
        },
        isRdmGiftShopListOpen() {
            return this.$store.getters.isRdmGiftShopListOpen;
        },
        product() {
            return this.$store.getters.rdmGiftProdList.find(
                p => p.id == this.$route.params.id
            );
        },
        productDisplayFullname() {
            return this.$store.getters.productDisplayFullname(
                this.product,
                true
            );
        },
        prodCatgDesp() {
            const prodCatgList = this.$store.state.prodCatgList;
            const prodCatg = prodCatgList.filter(
                prodCatg => prodCatg.id === this.product.prodCatgSlctKey
            );
            return this.product.prodCatgSlctKey ? prodCatg[0].slctDesp : '其他';
        },
        productLinks() {
            return this.$store.getters.getProdLinksByProdKey(
                this.product.prodKey
            );
        },
        maxQty() {
            return this.maxCustOrdQty
                ? Math.min(this.maxCustOrdQty, this.productActualRemainingQty)
                : this.productActualRemainingQty;
        },
        maxCustOrdQty() {
            return this.$store.getters.getProductMaxOrdQtyPerPerson(
                this.product
            );
        },
        productActualRemainingQty() {
            return this.$store.getters.productActualRemainingQty(this.product);
        },
        saleCatgRefPrcName() {
            return (
                this.product.custRefPrcName ||
                this.$store.getters.saleCatgRefPrcName(this.product)
            );
        },
        saleCatgUnitPrcName() {
            return (
                this.product.custUnitPrcName ||
                this.$store.getters.saleCatgUnitPrcName(this.product)
            );
        }
    }
};
</script>
